import { TTabsSize, TTabRowVariant } from '@shared-components/types';

export const tabsContentStyles = { width: '100%' };

export const getTabsListWrapStyles = (params?: { tabRowVariant?: TTabRowVariant; isSmallScreen?: boolean }) => ({
	borderBottom: 1,
	borderColor: 'divider',
	...(params?.tabRowVariant === 'Filled' && {
		backgroundColor: 'neutrals.neutral',
		paddingLeft: params?.isSmallScreen ? 0 : '5%',
		paddingRight: params?.isSmallScreen ? 0 : '5%',
		borderColor: 'neutrals.disabled',

		'& .MuiTabs-indicator': {
			display: 'none',
		},
	}),
});

export const getTabsWrapperStyles = (params?: {
	tabRowVariant?: TTabRowVariant;
	isTabsFixed?: boolean;
	headerPositioning?: { minHeight: { xs: string; md: string } };
	withDisappearingHeader?: boolean;
	desktopHeaderDisappearingTopStyle?: string;
	mobileHeaderDisappearingTopStyle?: string;
}) => {
	const xsHeaderMinHeight = params?.headerPositioning?.minHeight.xs ?? '0rem';
	const mdHeaderMinHeight = params?.headerPositioning?.minHeight.md ?? '0rem';

	const xsDisappearingHeader = params?.mobileHeaderDisappearingTopStyle === '0px' ? xsHeaderMinHeight : '0rem';
	const mdDisappearingHeader = params?.desktopHeaderDisappearingTopStyle === '0px' ? mdHeaderMinHeight : '0rem';

	return {
		position: params?.isTabsFixed ? 'fixed' : 'static',
		background: 'white',
		top: params?.isTabsFixed
			? {
					xs: params.withDisappearingHeader ? xsDisappearingHeader : xsHeaderMinHeight,
					md: params.withDisappearingHeader ? mdDisappearingHeader : mdHeaderMinHeight,
			  }
			: 'auto',
		left: 0,
		transition: 'top 0.5s ease-in-out',
		width: '100%',
		zIndex: 12,
		borderBottom: 1,
		borderColor: 'divider',
		marginBottom: '-1px',
		...(params?.tabRowVariant === 'Filled' && {
			backgroundColor: 'neutrals.neutral',
		}),
	};
};

export const tabsStyles = {
	marginBottom: '-1px',
	'& .MuiTabs-flexContainer': {
		justifyContent: 'space-evenly',
	},
	'& .MuiTabs-indicator': {
		backgroundColor: 'text.interactive',
	},
};

export const getTabStyles = (params?: {
	tabsSize?: TTabsSize;
	tabRowVariant?: TTabRowVariant;
	isSmallScreen?: boolean;
}) => ({
	textTransform: 'none',
	color: 'text.secondary',
	'&.Mui-selected': {
		color: 'text.interactive',
	},
	...((params?.tabsSize === 'Medium' || params?.tabsSize === 'Small' || params?.isSmallScreen) && {
		padding: '0.75rem 1rem',
		fontSize: '1rem',
		lineHeight: '1.625rem',
	}),
	...(params?.tabsSize === 'Large' &&
		params?.isSmallScreen !== true && {
			padding: '1.5rem 1rem',
			fontSize: '2rem',
			lineHeight: '2.125rem',
		}),
	...(params?.tabRowVariant === 'Filled' && {
		backgroundColor: 'neutrals.neutral',
		color: 'text.primary',
		borderBottom: 1,
		borderColor: 'neutrals.disabled',
		'&.Mui-selected': {
			color: 'text.interactive',
			backgroundColor: 'neutrals.white',
			border: 1,
			borderBottom: 'none',
			borderColor: 'neutrals.disabled',
			borderRadius: '1.5rem 1.5rem 0 0',
			marginBottom: '-1px',

			'&:first-of-type': {
				...(params?.isSmallScreen && { borderRadius: '0 1.5rem 0 0', borderLeft: 0 }),
			},
			'&:last-of-type': {
				...(params?.isSmallScreen && { borderRadius: '1.5rem 0rem 0 0', borderRight: 0 }),
			},
		},
	}),
});

export const getTabPanelStyles = (params?: { withContentInnerGap?: boolean; isSmallScreen?: boolean }) => ({
	...(params?.withContentInnerGap && params?.isSmallScreen !== true && { padding: '0 6rem' }),
});
